import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Image from "react-bootstrap/Image";

import LinkComponent from "../../Link";
import useWidthHook from "../../../Hooks/useWidth";
import LogoIcon from "../../../Icons/Logo";

const propTypes = {
  href: PropTypes.string,
  logo: PropTypes.string,
  className: PropTypes.string,
  action: PropTypes.shape({
    onClick: PropTypes.func,
    icon: PropTypes.any,
    name: PropTypes.string
  })
};

const defaultProps = {
  className: ""
};

const Template = ({ href, logo, action, className, children }) => {
  /**
   * variables
   */
  const width = useWidthHook();

  return (
    <Wrapper
      $withLogo={Boolean(logo)}
      className={`position-sticky bg-white ${className}`}
    >
      <div className="d-flex align-items-center gap-6">
        {action && (
          <LinkComponent
            onClick={() => action?.onClick()}
            className="d-flex align-items-center gap-3 px-3 text-decoration-none text-black"
          >
            <Fragment>
              {action?.icon && action.icon}
              {width >= 768 && action?.name && (
                <small className="fw-bold">{action.name}</small>
              )}
            </Fragment>
          </LinkComponent>
        )}
      </div>

      <LogoWrapper
        aria-label="Logo"
        {...(href && { onClick: () => (window.location.href = href) })}
      >
        <span className="logo">
          <LogoIcon className="m-auto" />
        </span>
        {logo && (
          <Fragment>
            <span className="separator" />
            <span className="logo">
              <Image src={logo} fluid className="m-auto" />
            </span>
          </Fragment>
        )}
      </LogoWrapper>

      <div className="d-flex align-items-center gap-6 justify-content-end">
        {children}
      </div>
    </Wrapper>
  );
};

/**
 * style
 */
const LogoWrapper = styled(LinkComponent)`
  gap: 1rem;
  display: flex;
  align-items: center;

  .separator {
    flex: 0 0 1px;
    height: 2.5rem;
    background-color: var(--bs-gray-20);
  }

  .logo {
    height: 2.5rem;
    display: flex;
    flex: 0 0 3.5rem;
    padding: 0 0.25rem;

    svg {
      width: 100%;
    }

    img {
      max-height: 100%;
    }
  }
`;

const Wrapper = styled.nav`
  top: 0;
  gap: 1.5rem;
  z-index: 100;
  display: grid;
  height: 3.5rem;
  padding: 0 1rem;
  align-items: center;
  border-bottom: solid 0.0625rem var(--bs-gray-20);
  grid-template-columns: ${({ $withLogo }) =>
    `minmax(0, 1fr) ${$withLogo ? "9rem" : "4rem"} minmax(0, 1fr)`};

  button {
    max-height: 2.25rem;
  }

  @media (min-width: 768px) {
    padding: 0 2rem;

    button {
      max-height: 3rem;
    }
  }

  @media (min-width: 992px) {
    padding: 0 2.5rem;
    height: 5rem;
  }
`;

Template.propTypes = propTypes;
Template.defaultProps = defaultProps;

export default Template;
